import { render } from "./ResetPasswordUser.vue?vue&type=template&id=5fcc1a48"
import script from "./ResetPasswordUser.vue?vue&type=script&lang=js"
export * from "./ResetPasswordUser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__